// src/pages/AdminPanelPage.js
//
// Admin Panel (hub)
// ==================
//
// Goal:
// - Same look & feel as your "User Management hub" subpages.
// - Clean, card-based layout.
// - No global CSS side-effects.
// - Buttons are "tiles" with title + short description + chip.
//
// i18n note:
// - This page is a navigation hub only. Route targets remain stable technical
//   contracts, while titles, descriptions, chips and helper text are translated
//   through the admin namespace.
// - Keep the structure deliberately simple: this page should not duplicate
//   business logic from the underlying admin modules.
//

import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./AdminPanelPage.css";

export default function AdminPanelPage() {
  const navigate = useNavigate();
  const { t } = useTranslation(["admin"]);

  return (
    <div className="admin-hub">
      <div className="admin-hub__inner">
        {/* Header */}
        <div className="admin-hub__header">
          <div className="admin-hub__title">
            <h1>{t("admin:panel.title")}</h1>
            <p>{t("admin:panel.subtitle")}</p>
          </div>
        </div>

        {/* Main card */}
        <div className="admin-hub__card">
          <div className="admin-hub__grid">
            {/* 1) User Management */}
            <div className="admin-hub__item">
              <button
                type="button"
                className="admin-hub__tile"
                onClick={() => navigate("/admin/users")}
              >
                <div className="admin-hub__tileHead">
                  <span className="admin-hub__tileTitle">
                    {t("admin:panel.tiles.userManagement.title")}
                  </span>
                  <span className="admin-hub__chip">
                    {t("admin:panel.tiles.userManagement.chip")}
                  </span>
                </div>
                <div className="admin-hub__tileDesc">
                  {t("admin:panel.tiles.userManagement.description")}
                </div>
              </button>
            </div>

            {/* 2) Announcement Management */}
            <div className="admin-hub__item">
              <button
                type="button"
                className="admin-hub__tile"
                onClick={() => navigate("/announcement")}
              >
                <div className="admin-hub__tileHead">
                  <span className="admin-hub__tileTitle">
                    {t("admin:panel.tiles.announcementManagement.title")}
                  </span>
                  <span className="admin-hub__chip admin-hub__chip--info">
                    {t("admin:panel.tiles.announcementManagement.chip")}
                  </span>
                </div>
                <div className="admin-hub__tileDesc">
                  {t("admin:panel.tiles.announcementManagement.description")}
                </div>
              </button>
            </div>

            {/* 3) System Settings */}
            <div className="admin-hub__item">
              <button
                type="button"
                className="admin-hub__tile"
                onClick={() => navigate("/settings")}
              >
                <div className="admin-hub__tileHead">
                  <span className="admin-hub__tileTitle">
                    {t("admin:panel.tiles.systemSettings.title")}
                  </span>
                  <span className="admin-hub__chip admin-hub__chip--warn">
                    {t("admin:panel.tiles.systemSettings.chip")}
                  </span>
                </div>
                <div className="admin-hub__tileDesc">
                  {t("admin:panel.tiles.systemSettings.description")}
                </div>
              </button>
            </div>
          </div>

          {/* Hint line */}
          <div className="admin-hub__hint">
            <Trans
              i18nKey="admin:panel.masterDataTip"
              components={{ strong: <b /> }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
